export default __webpack_public_path__ + "static/media/ss-logo.8b3ece80.png";